<header data-pgr-id="app-header" class="p-4">
  <div data-pgr-id="app-header-minimal" class="logo-header flex items-center">
    <div class="logo-container size-auto flex items-center">
      <img src="assets/logo-progressive.svg" />
    </div>
  </div>
</header>
<div class="login-container flex justify-center items-center">
  <mat-card
    class="max-sm:mx-xxs overflow-hidden p-0 login-card"
    data-pgr-id="cardWelcome"
  >
    @if (redirect()) {
    <cla-redirect-prompt data-pgr-id="promptError"> </cla-redirect-prompt>
    } @else if (errorMessage()) {
    <cla-error-prompt
      data-pgr-id="promptError"
      [errorMessage]="errorMessage()"
      (onClose)="clearError()"
    ></cla-error-prompt>
    } @else {
    <mat-card-header
      class="p-0 my-xxs mx-xs login-header"
      data-pgr-id="cardWelcomeHeader"
    >
      <mat-card-title class="login-title" data-pgr-id="cardWelcomeTitle">
        PROGRESSIVE LOSS VIEWER
      </mat-card-title>
    </mat-card-header>
    <div class="login-horizontal-line"></div>
    <mat-card-content class="my-xxs mx-xs">
      <span class="welcome-banner pb-xxs">Welcome</span>
      <div class="flex flex-col space-y-xxs">
        @if (!showSsoLogin()) {
        <cla-login-prompt
          data-pgr-id="promptLogin"
          (onCredentialLogin)="handleCredentialAuth()"
          (onSsoLogin)="showSSOPrompt()"
          (onMfaConfigure)="configureMfa()"
        ></cla-login-prompt>
        } @else {
        <cla-sso-prompt
          data-pgr-id="promptSso"
          (onCancel)="hideSSOPrompt()"
          (onSubmit)="handleSSOAuth($event)"
        ></cla-sso-prompt>
        }
      </div>
    </mat-card-content>
    }
  </mat-card>
</div>
